<template>

  <div class="input-invalid-feedback">
    <b-form-invalid-feedback v-if="(isErrorExist('required') && !errors.required && attribute !='file') || errorsComment">
      {{$t(this.$getConst.pages.form.required_field_error)}}.
    </b-form-invalid-feedback>
    <b-form-invalid-feedback v-if="(isErrorExist('required') && !errors.required && attribute =='file')">
      {{$t(this.$getConst.pages.form.upload_document_absence)}}.
    </b-form-invalid-feedback>

    <!--  Types errors  -->
    <b-form-invalid-feedback v-if="isErrorExist('email') && !errors.email">
      {{$t(this.$getConst.pages.form.email_field_error)}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="emailError" >
      {{$t(this.$getConst.pages.form.email_field_error_unique)}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('url') && !errors.url">
      {{$t(this.$getConst.pages.form.url_field_error)}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('alpha') && !errors.alpha">
      {{$t(this.$getConst.pages.form.alpha_field_error)}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('alphaNum') && !errors.alphaNum">
      {{$t(this.$getConst.pages.form.alphaNum_field_error)}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('numeric') && !errors.numeric">
      {{$t(this.$getConst.pages.form.numeric_field_error)}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('integer') && !errors.integer">
      {{$t(this.$getConst.pages.form.integer_field_error)}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('decimal') && !errors.decimal">
      {{$t(this.$getConst.pages.form.decimal_field_error)}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('matchUrl') && !errors.matchUrl">
      {{$t(this.$getConst.pages.form.nav_endpoint_field_error)}}.
    </b-form-invalid-feedback>
    <!--  End Types errors  -->

    <!--  Size errors  -->
    <b-form-invalid-feedback v-if="isErrorExist('minLength') && !errors.minLength">
      {{$t(this.$getConst.pages.form.minLength_field_error)}} {{errors.$params.minLength.min}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('maxLength') && !errors.maxLength">
      {{$t(this.$getConst.pages.form.maxLength_field_error)}} {{errors.$params.maxLength.max}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('minValue') && !errors.minValue">
      {{$t(this.$getConst.pages.form.minValue_field_error)}} {{errors.$params.minValue.min}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('maxValue') && !errors.maxValue">
      {{$t(this.$getConst.pages.form.maxValue_field_error)}} {{errors.$params.maxValue.max}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('between') && !errors.between">
      {{$t(this.$getConst.pages.form.between_field_error)}} [{{errors.$params.between.min}}-{{errors.$params.between.max}}].
    </b-form-invalid-feedback>
    <!--  End Size errors  -->

    <b-form-invalid-feedback v-if="isErrorExist('sameAs') && !errors.sameAs">
      {{$t(this.$getConst.pages.form.sameAs_field_error)}}.
    </b-form-invalid-feedback>

    <b-form-invalid-feedback v-if="isErrorExist('isExist') && !errors.isExist">
      {{$t(this.$getConst.pages.form.exist_field_error)}}.
    </b-form-invalid-feedback>
  </div>
</template>

<script>
  export default {
    name: "AppFormFeedback",
    props: {
      attribute: {
        type: String
      },
      errorsComment: {
        type: Boolean,
        default: false
      },
      errors: {
        type: Object,
        required: true
      },
      emailError: {
        type: String
      }
    },
    computed: {
      errorsList() {
        return Object.keys(this.errors);
      }
    },
    methods: {
      isErrorExist(error) {
        return this.errorsList.indexOf(error) > -1;
      }
    }
  }
</script>

<style scoped>

</style>
